export default "__VITE_ASSET__D8ew8Hl9__"